import * as React from 'react'

import type {BuildId} from '../../../types'

import CompareBuildsHeader from './CompareBuildsHeader/CompareBuildsHeader.container'
import CompareBuildsTabs from './CompareBuildsTabs/CompareBuildsTabs.container'

type Props = {
  sourceId: BuildId
  compareWithId: BuildId | null | undefined
}

function CompareBuildsPage({sourceId, compareWithId}: Props) {
  return (
    <>
      <CompareBuildsHeader sourceId={sourceId} compareWithId={compareWithId} />
      <CompareBuildsTabs sourceId={sourceId} compareWithId={compareWithId} />
    </>
  )
}

export default CompareBuildsPage
